
const META_PIXEL_ID = '1811610693518260'

type MetaPixelArguments = [string, ...unknown[]]

type MetaPixelFunction = ((...args: MetaPixelArguments) => void) & {
  callMethod?: (...args: MetaPixelArguments) => void
  queue?: MetaPixelArguments[]
  push?: (args: MetaPixelArguments) => void
  loaded?: boolean
  version?: string
}

declare global {
  interface Window {
    fbq?: MetaPixelFunction
    _fbq?: MetaPixelFunction
  }
}

export function initializeMetaPixel(): void {
  if (typeof window === 'undefined' || window.fbq?.loaded) {
    return
  }

  const existingScript = document.querySelector<HTMLScriptElement>(
    'script[data-meta-pixel-id="1811610693518260"]',
  )

  const fbq = function (...args: MetaPixelArguments): void {
    if (fbq.callMethod) {
      fbq.callMethod(...args)
      return
    }

    fbq.queue?.push(args)
  } as MetaPixelFunction

  window.fbq = fbq
  window._fbq = fbq
  fbq.push = (args) => fbq.queue?.push(args)
  fbq.loaded = true
  fbq.version = '2.0'
  fbq.queue = []

  if (!existingScript) {
    const script = document.createElement('script')
    script.async = true
    script.src = 'https://connect.facebook.net/en_US/fbevents.js'
    script.dataset.metaPixelId = META_PIXEL_ID
    document.head.appendChild(script)
  }

  fbq('init', META_PIXEL_ID)
  fbq('track', 'PageView')
}

